var map = {
	"./logo-alphabet.svg": 980,
	"./logo-amazon-2.svg": 981,
	"./logo-amazon.svg": 621,
	"./logo-azercell.svg": 712,
	"./logo-bank-of-america.svg": 612,
	"./logo-barclays.svg": 613,
	"./logo-bnp-paribas.svg": 614,
	"./logo-booking.svg": 560,
	"./logo-citibank.svg": 542,
	"./logo-coca-cola.svg": 982,
	"./logo-deloitte.svg": 983,
	"./logo-experian.svg": 984,
	"./logo-facebook.svg": 985,
	"./logo-goldman-sachs.svg": 615,
	"./logo-google.svg": 986,
	"./logo-h.svg": 987,
	"./logo-infineon.svg": 988,
	"./logo-instagram.svg": 989,
	"./logo-jp-morgan.svg": 616,
	"./logo-jti.svg": 886,
	"./logo-linkedin.svg": 990,
	"./logo-meta.svg": 991,
	"./logo-oracle.svg": 622,
	"./logo-paypal.svg": 543,
	"./logo-pwc.svg": 992,
	"./logo-tesla.svg": 544,
	"./logo-visa.svg": 623,
	"./logo-walmart.svg": 538,
	"./logo-youtube.svg": 993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 979;